import entries from '../content/whats-new.json';
import { can, isPlatform, isTenantAdmin } from './access';

export const safeProductPath = (path) => {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//') || /[\\\s]/.test(path)) return null;
  const route = path.split(/[?#]/)[0];
  return ['/', '/profile', '/admin', '/account', '/getting-started', '/query', '/resolutions', '/floor-space', '/analytics', '/team-users', '/org-chart', '/organisation', '/integrations', '/platform-operations'].includes(route) ? path : null;
};
export const updatesFor = (user) => entries.filter((entry) => {
  if (!safeProductPath(entry.path)) return false;
  if (entry.audience === 'everyone') return true;
  if (entry.audience === 'tenant-admin') return isTenantAdmin(user);
  if (entry.audience === 'platform') return isPlatform(user);
  if (entry.audience === 'knowledge') return can(user, 'can_manage_knowledge') || user?.is_source_lead === true;
  return false;
}).sort((a, b) => b.date.localeCompare(a.date));
export const unreadUpdates = (user, learning) => updatesFor(user).filter((entry) => !(learning?.updates_seen || []).includes(entry.id));
